
export default {
  // Home page
  "airport_rankings": "Clasificación de Aeropuertos",
  "recent_reviews": "Reseñas Recientes",
  "loading_reviews": "Cargando reseñas...",
  "no_reviews": "Aún no hay reseñas.",
  "share_experience": "Comparte Tu Experiencia",
  "help_photographers": "Ayuda a otros fotógrafos de película compartiendo tus experiencias en aeropuertos",
  "add_review": "Añadir Reseña",
  "loading_leaderboard": "Cargando clasificaciones...",
  "no_reviews_yet": "Aún no hay reseñas",
  "be_first": "¡Sé el primero en evaluar un aeropuerto!",
  "best_airports": "Mejores Aeropuertos",
  "worst_airports": "Peores Aeropuertos",
  "success_rate": "Tasa de Éxito",
  "airport_name": "Nombre del Aeropuerto",
  "airport_location": "Ubicación",
  "score": "Puntuación",
  "total_reviews": "Reseñas",
  "bottom_10_airports": "Los 10 peores aeropuertos según las reseñas de fotógrafos de película",
  "top_10_airports": "Los 10 mejores aeropuertos según las reseñas de fotógrafos de película",
  // Review tabs
  "all_reviews": "Todas las Reseñas",
  "verified_reviews": "Reseñas Verificadas",
  "no_verified_reviews": "Aún no hay reseñas verificadas.",
  "creative_reviews": "Reseñas de Creativos",
  "traveler_reviews": "Reseñas de Viajeros",
  "no_creative_reviews": "Aún no hay reseñas de creativos verificados.",
  "no_traveler_reviews": "Aún no hay reseñas de viajeros verificados."
};
